import styled from "styled-components";

export const ButtonCard = styled.button`
  padding: 0 0 0 0;
  text-align: left;
  border: none;
  display: flex;
  flex-direction: column;
  margin-bottom: 13px;
  justify-content: space-between;
  .description {
    background: white;
    padding: 10px 5px;
    height: calc(100% - 27px);
    color: #000000;
  }
  .title {
    font-weight: bolder;
    color: #1070b6;
    background-color: #d3e8ff;
    text-align: left;
    font-size: 16px;
    transform: scaleY(1.07);
    padding: 0 5px;
  }

  @media (min-width: 700px) {
    width: 320px;
    .title,
    .description {
      width: 100%;
    }
  }
  @media (max-width: 700px) {
    width: 260px;
    .title,
    .description {
      min-width: 100%;
    }
  }
  :hover,
  :active,
  :focus {
    transform: scale(1.02);
    cursor: pointer;
  }
`;

export const Layout = styled.p`
  margin-bottom: 8px;
`;

export const ListGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0;
`;
